import { useGlobalState } from "../store/store";
var useConnectWalletModal = function () {
    var _a = useGlobalState("showConnectWallet"), showConnectWallet = _a[0], setShowConnectWallet = _a[1];
    return [showConnectWallet, setShowConnectWallet];
};
export default useConnectWalletModal;
//# sourceMappingURL=useConnectWalletModal.js.map